
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audioknigi/[pageNumber]",
      function () {
        return require("private-next-pages/audioknigi/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audioknigi/[pageNumber]"])
      });
    }
  